import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import MainContent from '../components/boxes/MainContent';
import PageHeader from '../components/boxes/PageHeader';
import PageBody from '../components/boxes/PageBody';
import DataTable from "../components/boxes/DataTable";
import { ENDPOINTS } from '../services/ApiService';
import { invoicesListColumnData } from "../services/tableColumnData";
import { PERMISSIONS } from "../services/utilityService";
import RestrictedComponent from "../components/utils/RestrictedComponent";

class InvoicesContainer extends Component {
  showTableDetail = (id) => {
    return this.props.history.push(`/invoices/${id}`)
  }

  render() {
    const { user } = this.props;

    return (
      <MainContent>
        <PageHeader 
          title="Invoices"
          // showButton
          // buttonTitle="Add New Invoice"
          // onButtonClick={() => this.props.history.push("/invoices/new")}
        />
        <PageBody>
          <RestrictedComponent
            displayErrorMessage={true}
            errorComponent={() => (
              <div className="dashboard-card">
                <div style={{position:"relative", height:"10rem"}}>
                  <p className="dashboard-card__body-text">You don't have permission to view this.</p>
                </div>
              </div>
            )}
            condition={this.props.user.permissions.indexOf(PERMISSIONS.invoice.read_invoice) > -1}>

            <div className="dashboard-card dashboard-table-wrap">
              <DataTable
                dataSource={{
                  url:`${ENDPOINTS.invoices.base}`,
                  accessToken: user.credentials.accessToken
                }}
                tableColumnData={invoicesListColumnData}
                showTableDetail={this.showTableDetail}
              />
            </div>
          </RestrictedComponent>
        </PageBody>
      </MainContent>
    );
  }
}

export default withRouter(InvoicesContainer);